import Axios from 'axios';
import { ConsumptionParameters, ConsumptionResponse, MetricsResponse } from 'model/api';
import { toPairs } from 'lodash';
import { parameterObjectToQuery } from './common';

export const getConsumption = async (parameters: ConsumptionParameters): Promise<ConsumptionResponse> => {
  const query = parameterObjectToQuery(parameters);
  const response = await Axios.get(`/water/consumption${query}`);
  return response.data;
}

export const getMetrics = async (parameters: ConsumptionParameters): Promise<MetricsResponse> => {
  const params = toPairs(parameters).map(([param, value]: [string, string]) => `${param}=${value}`);
  const query = (params.length > 0) ? `?${params.join("&")}` : '';
  const response = await Axios.get(`/water/metrics${query}`);
  return response.data;
}